import { useMemo } from 'react'
import { PriceProps } from './Price.types'
import { getFormattedPrice } from './Price.utils'

export const usePrice = (props: PriceProps) => {
  const price = useMemo(() => getFormattedPrice(props), [props])
  return { price }
}

export const usePriceUtils = () => {
  return { getFormattedPrice }
}
